import { IPageProperty } from '@common/nav/navtypes';
import { Observable } from '@common/navdata/navmodel';

/** Util for Selection State */
export class NavPropertySelection extends Observable {
    public constructor(public Prop: IPageProperty, private Values: any[]) {
        super();
    }
    public get Count() { return this.Values && this.Values.length; }
    public Clone() {
        return new NavPropertySelection(this.Prop, this.Values && this.Values.slice());
    }
    public GetValues(targetProp: IPageProperty) {
        let result = this.Values;
        // TODO : Type Conversion
        if (targetProp && targetProp.Type === "String" && this.Prop.Type === "Decimal") {
            result = result.map(item => "" + item);
        }
        return result;
    }
    public SetAsAcurrent() {
        var target = NavPropertySelection.Current;
        target.Values = this.Values && this.Values.slice();
        target.Prop = this.Prop;
        target.trigger("change");
    }
    public static readonly Current: NavPropertySelection = new NavPropertySelection(undefined, undefined);
}
